"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleTable = void 0;
var _react = _interopRequireDefault(require("react"));
require("./simple-table.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SimpleTableRow = _ref => {
  let {
    columns,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "simple-table-row flex gap-4 py-3 ".concat(className || "")
  }, columns.map((col, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index,
    className: "simple-table-column"
  }, col.tooltip && col.tooltip, /*#__PURE__*/_react.default.createElement("span", null, col.content))));
};
const SimpleTable = exports.SimpleTable = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    header,
    rows,
    size = "md",
    className,
    mt = 8
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "simple-table mt-".concat(mt, " simple-table-").concat(size, " ").concat(className || ""),
    ref: ref
  }, header && /*#__PURE__*/_react.default.createElement("h4", {
    className: "fs-body mb-3"
  }, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "simple-table-body"
  }, Object.values(rows).map((row, index) => /*#__PURE__*/_react.default.createElement(SimpleTableRow, _extends({
    key: index
  }, row)))));
});